export default "__VITE_ASSET__f9f3fecd__"